import { useState } from 'react';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { Button } from "react-bootstrap";
import { toast } from 'react-toastify';
import './XDocList';
import QRCode from 'react-qr-code';

const ClubAccess = ({ memberEmail, memberName, onSendToParent }) => {
  const db = getFirestore();
  const getLogsCollectionName = (date = new Date()) => {
    const year = date instanceof Date ? date.getFullYear() : new Date().getFullYear();
    return `access_logs_${year}`;
  };
  const [isLogging, setIsLogging] = useState(false);

  const handleAction = async () => {
    if (isLogging) return;
    setIsLogging(true);
    const ts = new Date();
    try {
      await addDoc(collection(db, getLogsCollectionName()), {
        fullName: memberName,
        entryType: "Member",
        method: "Club Access Entry",
        // Force rawPayload to be the email for the Index
        rawPayload: memberEmail.toLowerCase(),
        signedInBy: "",
        isExpired: false,
        isFlagged: false,
        hasIncident: false,
        scannedAt: ts,
      });
      onSendToParent(true)
    } catch (e) {
      toast.error("Log failed");
    } finally {
      setIsLogging(false);
    }
  };

  return (


    <Button onClick={handleAction}>
      <div className="image-focus-wrapper hoverX">
        <QRCode value={memberEmail} size={50} className="" bgColor="transparent" fgColor={"#0b0b0b"} level="M" />
      </div>
      <span className="orange"><strong>Self Check In</strong></span>
    </Button>

  );
};

export default ClubAccess;